import React from "react";
import Switch, { ISwitchOptions } from "devextreme-react/switch";
import {
  configureMdaeWidgetOptionUpdaters,
  DX_WIDGET_NAMES,
  IMdaeDataUpdaterConfig,
} from "../../mdae-framework";
import { useDispatch } from "react-redux";

interface IMdaeSwitchProps extends ISwitchOptions {
  mdaeDataUpdaterConfig?: Array<IMdaeDataUpdaterConfig>;
}

const MdaeSwitch: React.FC<IMdaeSwitchProps> = (props) => {
  const dispatch = useDispatch();
  return (
    <div>
      <Switch
        {...props}
        onInitialized={(e) => {
          if (typeof props.onInitialized === "function") props.onInitialized(e);
          configureMdaeWidgetOptionUpdaters(
            props.mdaeDataUpdaterConfig,
            DX_WIDGET_NAMES.DX_SELECT_BOX,
            e.component,
            dispatch
          );
        }}
      ></Switch>
    </div>
  );
};
export default MdaeSwitch;
